import React, { Fragment, useContext } from 'react';
import { Container, Row, Col } from 'reactstrap';
import { Link } from 'react-router-dom';
import H3 from '../Headings/H3Element';
import CustomizerContext from '../../_helper/Customizer';
import SvgIcon from '../../Components/Common/Component/SvgIcon';

const Breadcrumbs = (props) => {
	const { layoutURL } = useContext(CustomizerContext);
	return (
		<Fragment>
			<Container fluid={true}>
				<div
					className='page-title py-2'
					style={{
						paddingTop: '8px',
						paddingBottom: '8px',
						marginBottom: '12px',
					}}
				>
					<Row className='align-items-center'>
						<Col xs='6'>
							<H3
								attrH3={{
									className: 'tw-text-base mb-0 fw-semibold text-capitalize',
									style: { fontSize: '1rem', lineHeight: '1.5', marginBottom: 0 },
								}}
							>
								{props.mainTitle}
							</H3>
						</Col>
						<Col xs='6'>
							<div className={`d-flex align-items-center justify-content-end${props.action ? ' gap-2' : ''}`}>
								{props.action}
								<ol
									className='breadcrumb mb-0 py-0 align-items-center'
									style={{
										...(props.action ? { width: 'auto' } : {}),
										fontSize: '12px',
									}}
								>
									<li className='breadcrumb-item'>
										<Link to={`${process.env.PUBLIC_URL}/dashboard`} className='d-inline-flex align-items-center'>
											<SvgIcon iconId='stroke-home' style={{ width: '13px', height: '13px' }} />&nbsp;{props.parent}
										</Link>
									</li>
									{props.subParent ? <li className='breadcrumb-item'>{props.subParent}</li> : ''}
									<li className='breadcrumb-item active'>{props.title}</li>
								</ol>
							</div>
						</Col>
					</Row>
				</div>
			</Container>
		</Fragment>
	);
};

export default Breadcrumbs;
